export const CHECKING_REGISTRATION_DOCUMENT_STATUS_ROUTE = 'sprawdz-status-dowodu-rejestracyjnego';
